// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uxV3","left":"styles_left__SdfEd"};